<div class="sidebar-secondary-button">
  <a
    class="sidebar-secondary-button"
    href="{{ link }}"
    target="_blank"
    rel="noopener noreferrer"
    mat-flat-button
    color="primary"
    ><ng-content
  /></a>
</div>
